import { lazyWithRetry } from '@/shared/utils/lazyWithRetry';

export const Callback = lazyWithRetry(() => import('@/view/screens/Callback/Callback.view'));
export const SourceDataPage = lazyWithRetry(
  () => import('@/view/screens/DataSourcePage/DataSourcePage.view'),
);
export const HomePage = lazyWithRetry(() => import('@/view/screens/HomePage/HomePage.view'));
export const ProjectsPage = lazyWithRetry(
  () => import('@/view/screens/ProjectsPage/ProjectsPage.view'),
);
export const RegisterData = lazyWithRetry(
  () => import('@/view/screens/RegisterPage/RegisterPage.view'),
);
export const SettingPage = lazyWithRetry(
  () => import('@/view/screens/SettingPage/SettingPage.view'),
);
export const WorkspacesPage = lazyWithRetry(
  () => import('@/view/screens/WorkspacesPage/WorkspacesPage.view'),
);
export const DataStudio = lazyWithRetry(() => import('@/view/screens/DataStudio/DataStudio.view'));
export const DataEgressPage = lazyWithRetry(
  () => import('@/view/screens/DataEgressPage/DataEgressPage.view'),
);
export const McpPage = lazyWithRetry(() => import('@/view/screens/McpPage/McpPage.view'));
export const UploadSessionPage = lazyWithRetry(
  () => import('@/view/screens/UploadSessionPage/UploadSessionPage.view'),
);
export const ExportDownloadPage = lazyWithRetry(
  () => import('@/view/screens/ExportDownloadPage/ExportDownloadPage.view'),
);
export const UnsubscribePage = lazyWithRetry(
  () => import('@/view/screens/UnsubscribePage/UnsubscribePage.view'),
);
export const BillingPage = lazyWithRetry(
  () => import('@/view/screens/BillingPage/BillingPage.view'),
);
export const MarketplacePage = lazyWithRetry(
  () => import('@/view/screens/MarketplacePage/MarketplacePage.view'),
);
export const DataSharesPage = lazyWithRetry(
  () => import('@/view/screens/DataSharesPage/DataSharesPage.view'),
);
export const KnowledgePage = lazyWithRetry(
  () => import('@/view/screens/KnowledgePage/KnowledgePage.view'),
);
export const DashboardPage = lazyWithRetry(
  () => import('@/view/screens/DashboardPage/DashboardPage.view'),
);
export const PresentationsPage = lazyWithRetry(
  () => import('@/view/screens/PresentationsPage/PresentationsPage.view'),
);
export const CronSchedulerPage = lazyWithRetry(
  () => import('@/view/screens/CronSchedulerPage/CronSchedulerPage.view'),
);
export const AlertsPage = lazyWithRetry(() => import('@/view/screens/AlertsPage/AlertsPage.view'));
export const DiagnosticPage = lazyWithRetry(
  () => import('@/view/screens/DiagnosticPage/DiagnosticPage.view'),
);
export const AdminPage = lazyWithRetry(() => import('@/view/screens/AdminPage/AdminPage.view'));
export const DataConsolePage = lazyWithRetry(
  () => import('@/view/screens/DataConsolePage/DataConsolePage.view'),
);
export const AuditLogsPage = lazyWithRetry(
  () => import('@/view/screens/AuditLogsPage/AuditLogsPage.view'),
);
export const CreditsPage = lazyWithRetry(
  () => import('@/view/screens/CreditsPage/CreditsPage.view'),
);
export const ReportsPage = lazyWithRetry(
  () => import('@/view/screens/ReportsPage/ReportsPage.view'),
);
export const PrivateConnectionsPage = lazyWithRetry(
  () => import('@/view/screens/PrivateConnectionsPage/PrivateConnectionsPage.view'),
);
export const ShareDashboardPage = lazyWithRetry(
  () => import('@/view/screens/ShareDashboardPage/ShareDashboardPage.view'),
);
export const AgentPage = lazyWithRetry(() => import('@/view/screens/AgentPage/AgentPage.view'));
